import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const PricingSuccess = () => {
    const [searchParams] = useSearchParams();
    const [sessionStatus, setSessionStatus] = useState(null);
    const [loading, setLoading] = useState(true);
    const sessionId = searchParams.get('session_id');

    useEffect(() => {
        if (sessionId) {
            checkPaymentStatus(sessionId);
        }
    }, [sessionId]);

    const checkPaymentStatus = async (sessionId) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL || window.location.origin;
            const response = await fetch(`${backendUrl}/api/subscriptions/status/${sessionId}`);
            
            if (response.ok) {
                const data = await response.json();
                setSessionStatus(data);
            }
        } catch (error) {
            console.error('Error checking payment status:', error);
        } finally {
            setLoading(false);
        }
    };

    // Notify parent window if in iframe
    useEffect(() => {
        if (sessionStatus && sessionStatus.payment_status === 'paid') {
            window.parent.postMessage({
                type: 'PAYMENT_SUCCESS',
                session_id: sessionId,
                status: sessionStatus
            }, '*');
        }
    }, [sessionStatus, sessionId]);

    return (
        <div className="min-h-screen bg-[#1E2330] flex items-center justify-center p-4">
            <div className="max-w-md mx-auto text-center text-white">
                {loading ? (
                    <div>
                        <div className="animate-spin w-8 h-8 border-4 border-[#FFD700] border-t-transparent rounded-full mx-auto mb-4"></div>
                        <h2 className="text-2xl font-bold mb-2">Bekrefter betaling...</h2>
                        <p className="text-[#E0E0E0]">Vennligst vent mens vi bekrefter din betaling.</p>
                    </div>
                ) : sessionStatus?.payment_status === 'paid' ? (
                    <div>
                        <div className="w-16 h-16 bg-[#66D468] rounded-full flex items-center justify-center mx-auto mb-6">
                            <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                        </div>
                        <h2 className="text-2xl font-bold mb-2 text-[#66D468]">Betaling vellykket!</h2>
                        <p className="text-[#E0E0E0] mb-4">
                            Takk for din bestilling av Aktivlogg abonnement.
                        </p>
                        <p className="text-sm text-[#E0E0E0]">
                            Du vil motta en bekreftelse på e-post med instruksjoner for å komme i gang.
                        </p>
                    </div>
                ) : (
                    <div>
                        <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
                            <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                            </svg>
                        </div>
                        <h2 className="text-2xl font-bold mb-2 text-red-600">Betaling ikke fullført</h2>
                        <p className="text-[#E0E0E0]">
                            Det ser ut til at betalingen ikke ble fullført. Vennligst prøv igjen.
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PricingSuccess;